module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Heavy-f7376a8c65db73a31f7bd3631622d6ba.ttf";